import {Group} from '@mantine/core';
import React from 'react';

import {MetadataGridContents} from 'analysis-tool/data-view/metadata-modal/ViewMetadataModal';
import {isInaccessible} from 'graphql-client/InaccessibleInfo';
import {ButtonStyle} from 'ui-library/buttons/Button';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';
import Modal from 'ui-library/modals/Modal';
import {readableTime} from 'util/DateUtil';

import {CanvasFolderArtifactFileStateGraphQL} from '../backbone/CanvasFolderArtifactGraphQL';

export interface CanvasFolderArtifactMetadataModalProps {
  artifact: CanvasFolderArtifactFileStateGraphQL;
  onRequestClose: () => void;
  onRequestSubmit: () => void;
}

export default function CanvasFolderArtifactMetadataModal({
  artifact,
  onRequestClose,
  onRequestSubmit,
}: CanvasFolderArtifactMetadataModalProps): JSX.Element {
  const creatorName = isInaccessible(artifact.creator) ? null : artifact.creator.name;

  return (
    <Modal
      title="Metadata"
      mediumLarge={true}
      buttons={[{style: ButtonStyle.PRIMARY, submit: true, text: 'Done'}]}
      onRequestClose={onRequestClose}
      onRequestSubmit={onRequestSubmit}
      dataTestAttrs={{component: 'CanvasFolderArtifactMetadataModal', element: 'root'}}
    >
      <MetadataGridContents
        gridCells={[
          {label: 'Created by', component: creatorName ?? '—'},
          {label: 'Created', component: readableTime(artifact.createdAt)},
          {
            label: 'Folder',
            component: (
              <Group spacing="xs" noWrap={true}>
                <BenchlingIcon icon="folder" />
                {artifact.folder.name}
              </Group>
            ),
          },
          {label: 'Modified', component: readableTime(artifact.modifiedAt)},
        ]}
      />
    </Modal>
  );
}
